import { diffDay, addDays, NO_START, NO_END } from 'ha/helpers/hadate';
import getToday from 'ha/helpers/hadate/getToday';
import { ISODate } from 'ha/helpers/hadate/types';

export default (startDate: ISODate, endDate: ISODate) => {
  const today = getToday();
  const diffTodayStart = diffDay(today, startDate);
  const diffTodayEnd = diffDay(today, endDate);

  if (diffTodayStart < 0) {
    return { from: today, to: addDays(startDate, -1) };
  }

  if (diffTodayEnd >= 0) {
    return { from: NO_START, to: NO_END };
  }

  return { from: NO_START, to: NO_START };
};
